import React from "react";
import * as dc from "dc";
import * as d3 from "d3";
import reductio from "reductio";
import { ChartTemplate } from "../../mapanalysis/chartTemplate";

const totallivestockChartFunc = (divRef, ndx) => {
  const total_livestock = ndx.dimension((d) => d.county);
  const total_livestock_grp = total_livestock
    .group()
    .reduceSum((d) => d.price_LV);

  const projects = dc.numberDisplay(divRef);
  projects.formatNumber(d3.format(",.0f"));
  projects.group(total_livestock_grp).valueAccessor((d) => {
    return d.value;
  });
  return projects;
};

export const TotalLivestockChart = (props) => (
  <ChartTemplate chartFunction={totallivestockChartFunc} />
);
